const COOKIE_SETTINGS_PORTAL_ID = 'cookie-settings-react-portal';
const COOKIE_SETTINGS_TRANSLATION_KEY = 'service_agreement_cookies.button.cookie_settings';

export {
    COOKIE_SETTINGS_PORTAL_ID,
    COOKIE_SETTINGS_TRANSLATION_KEY,
};
